import React, { useEffect, useState } from 'react';
import { PrincipalAuth } from '../../models/principalAuth';
import { Dialog, DialogActions, List, ListItem, ListItemText, makeStyles, Theme, Typography, useMediaQuery, useTheme, Button, DialogTitle, DialogContent, TextField } from '@material-ui/core';
import { Form, Formik, FormikProps, Field } from 'formik';
import { useGlobal } from 'reactn';
import { IGlobalState } from '../../states/GlobalState';
import { updatePrincipalAuth } from '../../services/principalAuthService';
import { LoggerServiceProvider, useLogger } from '../../logger';
import { UamTextField, UamSelectField } from '../../formik/UamTextField';
import { OptionType } from '../../types/constants';
import { getAgencies } from '../../services/agencyService';
import { AgencySearchModel, Agency } from '../../models/agency';
import { Principal } from '../../models/principal';

const useStyle = makeStyles((theme: Theme) => ({
    form: {
        paddingTop: '2px',
    },
    listItem: {
        padding: 0
    },
}));

interface Props {
    open: boolean;
    principalAuth: PrincipalAuth | undefined;
    principal: Principal | undefined;
    onCancel: () => void;
    fullScreen?: boolean;
    title: string;
    maxWidth?: 'xs' | 'sm' | 'md' | 'lg' | 'xl' | false, 
}

export default function PrincipalAuthModal(props: Props) {

    const classes = useStyle();
    const theme: Theme = useTheme();
    // const full = props.fullScreen !== undefined ? props.fullScreen : useMediaQuery(theme.breakpoints.down('sm'));
    const full = props.fullScreen;
    const {principalAuth, principal} = props;
    const [auth] = useGlobal<IGlobalState, 'auth'>('auth');
    const [ip] = useGlobal<IGlobalState, 'ip'>('ip');
    const [currentEditPrincipal] = useGlobal<IGlobalState, 'currentEditPrincipal'>('currentEditPrincipal');
    const logger = useLogger({key: 'principalAuth'});
    const [agencyList, setAgencyList] = React.useState<OptionType[]>([]);

    const getAgencyList = async () => {
        let myList: Agency[] = [];
        let model = new AgencySearchModel();
        model.CompanyId = currentEditPrincipal!.principal.CompanyId!;
        console.log('Console log della company dell\'utente in edit ' + model.CompanyId);
        let res = await (await getAgencies(ip, auth.authData!, auth.user!, model));
        myList = res?.ResultList;
        if (myList && myList.length > 0)
        {
            myList.forEach(x => {
                agencyList.push({label: x.Name, value: x.Id});
            })
        }
    }

    useEffect(() => {        
        getAgencyList();
    }, [props.principal?.Id])
    
    if (!principalAuth)
        return <div />;

    return (
        <Dialog
            open={props.open}
            fullScreen={false}
            fullWidth={true}
            maxWidth={props.maxWidth}
        >
            <DialogTitle>
                {props.title} Autorizzazione
            </DialogTitle>
                <Formik
                    initialValues={{
                        ...principalAuth
                    }}
                    onSubmit={(values, { setSubmitting }) => {
                        console.log('submit form');
                        const updPrincipalAuth = values as PrincipalAuth;
                        if (values.Id !== 0) {
                            // updPrincipalAuth.Principal = Principal.newItem();
                            // updPrincipalAuth.Principal.Id = principal!.Id;
                            updPrincipalAuth.Agency = Agency.newItem();
                            updPrincipalAuth.Agency.Id = values.AgencyId;
                        }
                        else {
                            updPrincipalAuth.Principal = null;
                        }
                        updatePrincipalAuth(ip, auth.authData!, auth.user!, updPrincipalAuth).then(pa => {
                            console.log('saved values');
                            props.onCancel();
                        })
                        .catch(error => {
                            logger.error('Error in saving data')
                        }).finally(() => {
                            setSubmitting(false);
                        })
                    }}
                >
                {(formprops: FormikProps<PrincipalAuth>) => {
                    const { isSubmitting, handleSubmit, values, dirty, submitForm, resetForm, isValid, errors } = formprops;
                    
                    const handleSave = () => {
                        submitForm();
                    } 
                    return (
                        <>  
                        <DialogContent>
                            <Form className={classes.form} translate>
                                {/* <Field.Switch
                                    label={t('entities:principalUpload.notify')}
                                    model={(x: PrincipalUpload) => x.notify}
                                /> */}
                                <TextField label='Principal' value={principal!.Username} fullWidth margin='dense' inputProps={{readonly: true}}/>
                                <UamSelectField label='Agency' options={agencyList} name='AgencyId' fullWidth margin='dense'/>
                            </Form>
                        </DialogContent>
                        <DialogActions>
                            <Button 
                                onClick={(e: any) => handleSave()} 
                                style={{marginRight: '4px'}}
                                type="submit"
                                color="primary"
                            >OK</Button>
                            <Button 
                                onClick={(e: any) => { props.onCancel(); }} 
                                style={{marginRight: '4px'}}
                                color="primary"
                            >Cancel</Button>
                        </DialogActions>
                        </>
                    )
                }}
                </Formik>
        </Dialog>
    )
}